<template>
    <UserWrapper :extraWidth="false">
            <div class="contact-detail">
                <div class="desktop-view">
                    <Loader v-if="loading" />
                    
                    <!-- Empty message when no contacts -->
                    <div v-if="showEmptyMessage && !loading" class="empty-message">
                        <p>企業からメッセージが届くとここに表示されます。</p>
                    </div>
                    
                    <!-- Table only shown when there are contacts -->
                    <table v-if="!showEmptyMessage && !loading">
                        <thead>
                            <tr>
                                <th style="width: 28%;">会社名</th>
                                <!-- <th style="width: 15%;">差出人</th> -->
                                <th style="width: 40%">件名</th>
                                <th style="width: 13%">受信日</th>
                                <th style="width: 13%">回答内容</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ContactList v-for="contact in contacts" :key="contact._id" :contact="contact"/>
                        </tbody>
                    </table>
                    
                    <!-- Pagination only shown when there are contacts and multiple pages -->
                    <div class="pagination-area" v-if="totalPages > 1 && !showEmptyMessage">
                        <Pagination :total-page="totalPages" :callback="changePage" />
                    </div>
                </div>
            </div>
        <template v-slot:footer>
            <Footer/>
        </template>
    </UserWrapper>
</template>

<script>
import Api from '@/config/api';
import moment from 'moment';
// import ProfileHeader from "@/components/header.vue";
import UserWrapper from '../UserWrapper.vue';
import Pagination from '../Pagination.vue';
import Loader from '../Loader.vue';
import Footer from '../Footer.vue';
import ContactList from './ContactList.vue';
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
export default {
    name: 'TopContacts',
    components: { UserWrapper, Pagination, Loader, Footer, ContactList },
    data(){
        return {
            loading: false,
            // contacts: [],
        }
    },
    computed: {
        ...mapGetters({ contacts:'getContacts', totalContacts: 'getTotalContacts' }),
        ...mapState({
            page: ({ contact }) => contact.currentPage,
        }),
        allContactsCount() {
            return this.contacts.length;
        },
        totalPages(){
            return this.totalContacts ? Math.ceil(this.totalContacts/20) : 0;
        },
        showEmptyMessage() {
            return this.contacts.length === 0;
        },
    },
    methods: {
        ...mapActions(['loadContacts']),
        ...mapMutations(['setPage']),
        changePage(page){
            this.setPage(page);
        },
        async loadTopContacts(){
            try {
                const token = await this.$auth.getToken();
                const headers = {
                    Authorization: `Bearer ${token}`,
                };
                // console.log(Api.endpoints);
                const contacts = await this.axios({
                    method: 'get',
                    url: Api.url(`${Api.endpoints.allMessages}?page=${page}`),
                    headers: headers,
                });
                // console.log(contacts);
                this.contacts = contacts.data.data;
            } catch (err) {
                console.log(err);
            }
        }
    },
    async created(){
        this.loading = true;
        this.setPage(1);
        await this.loadContacts(1);
        this.loading = false;
    },
    watch: {
        page: function(currentPage) {
            this.loadContacts(currentPage);
        }
    }
}
</script>

<style scoped>

.profile-detail-block table thead th {
    background: none !important;
}

h2 {
    font-size: 24px;
}

table{
    width: 100%;
    text-align: center;
    border-collapse: collapse;
}

tbody {
    word-break: break-word;
}
th {
    padding: 15px;
    font-size: 16px;
}
td {
    border-bottom: 1px solid #c4c4c4;
    padding: 8px;
    text-align: center;
    color: #2F2E41;
    font-size: 16px;
}

tr {
    text-align: center;
    border-bottom: 1px solid #c4c4c4;
}

.empty-message {
    text-align: center;
    padding: 40px 20px;
    color: #787878;
    font-size: 14px;
}

.empty-message p {
    margin: 0;
    font-size: 12px;
    float:left;
}

@media(max-width: 550px) {

    >>>.profile-detail-block table td {
        padding-left: 8px !important;
        min-height: 0px;
    }

    table thead {
        display: none !important;
    }

    table th {
        font-size: 12px !important;
    }

    .rg-title {
        font-size: 16px !important;
        padding-top: 10px;
        padding-left: 5px;
        font-weight: 700;
    }

    .contact-detail {
        padding: 0px !important;
        /* border: 1px solid rgba(1, 58, 61, 0.1); */
        /* box-shadow: 0px 0px 20px -2px rgba(1, 58, 61, 0.1); */
    }
    /* .desktop-view {
        display: none !important;
    } */
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  /* CSS rules for iPads in portrait mode */

  .contact-detail {
    padding: 0px ;
  }
 
  table th{
    font-size:16px;
  }

}

</style>